import {MaltStrategyCreationStepName, maltStrategyCreationSteps} from '@/profile-creation-wizard/config/steps/MaltStrategyCreationSteps';
import {ProfileCreationFunnelMode, RoutesConfig} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import ProfileCreationRouterHelper from '@/profile-creation-wizard/router/ProfileCreationRouterHelper';

const maltStrategyRoutesConfiguration: RoutesConfig = {
    routes: maltStrategyCreationSteps.map((step) => ProfileCreationRouterHelper.buildRouteFromStep(step, ProfileCreationFunnelMode.STRATEGY)),
    creationFirstStep: MaltStrategyCreationStepName.SIGNUP_HEADLINE,
    completionFirstStep: MaltStrategyCreationStepName.COMPLETION_LINKEDIN,
};

export default maltStrategyRoutesConfiguration;
